export enum MatchType {
    UsagetoWork = 1,
    WorktoWork = 2,
    ProducttoProduct = 3,
    UsagetoProduct = 4
}